/**
 * Event trigger buttons for consumer simulator
 */
export default function EventTriggers({ onTriggerEvent, disabled }) {
  const events = [
    {
      id: 'hurricane',
      icon: '🌊',
      name: 'Hurricane',
      description: 'Major storm causes $5M in claims',
      severity: 'high'
    },
    {
      id: 'wildfire',
      icon: '🔥',
      name: 'Wildfire',
      description: 'Wildfire season causes $3M in claims',
      severity: 'medium'
    },
    {
      id: 'accident_spike',
      icon: '🚗',
      name: 'Accident Spike',
      description: 'Bad weather increases accidents',
      severity: 'low'
    }
  ];

  const severityColors = {
    high: 'from-red-600 to-red-700',
    medium: 'from-orange-500 to-orange-600',
    low: 'from-yellow-500 to-yellow-600'
  };

  return (
    <div className="bg-[#1a1a1a] border-2 border-[#333] rounded-xl p-6 shadow-[0_5px_20px_rgba(0,0,0,0.5)]">
      <h3 className="text-xl font-semibold mb-2 text-[#667eea]">Trigger Event</h3>
      <p className="text-sm text-[#888] mb-6">
        Watch how pool losses affect YOUR premium
      </p>
      
      <div className="space-y-3">
        {events.map(event => (
          <button
            key={event.id}
            onClick={() => onTriggerEvent(event.id)}
            disabled={disabled}
            className={`w-full p-4 rounded-lg bg-gradient-to-r ${severityColors[event.severity]} text-white font-semibold transition-all hover:scale-105 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100`}
          >
            <div className="flex items-center gap-3">
              <span className="text-2xl">{event.icon}</span>
              <div className="text-left flex-1">
                <div className="font-bold">{event.name}</div>
                <div className="text-xs opacity-90">{event.description}</div>
              </div>
            </div>
          </button>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-[#333]">
        <p className="text-xs text-[#666] leading-relaxed">
          <strong className="text-[#888]">Tip:</strong> Even if YOU don't file a claim, 
          pool losses will increase YOUR premium. Try it!
        </p>
      </div>
    </div>
  );
}


